// EN
export const hotelRatesManager = {
  perNight: "/ Nacht",
  roomFallback: "Zimmer #{id}",

  header: {
    eyebrow: "Hauptraten",
    title: "Hotelraten",
    subtitle:
      "Legen Sie Grundraten an und wenden Sie sie auf ein oder mehrere Zimmer an. Abgeleitete Raten werden mit dem Channel Manager synchronisiert.",
    newMain: "Neue Hauptrate",
  },
  states: {
    loading: "Raten werden geladen…",
    emptyTitle: "Noch keine Raten",
    emptySubtitle:
      "Legen Sie die erste Hauptrate an, um Preise zu verwalten und mit dem Channel Manager zu synchronisieren.",
    createFirst: "Erste Rate anlegen",
  },
  card: {
    mainBadge: "Haupt",
    occupancy: "Bel. {count}",
    minStay: "Mind. {count} Nacht | Mind. {count} Nächte",
    editRate: "Rate bearbeiten",
    deleteRate: "Rate löschen",
    rooms: "Zimmer",
    syncedTooltip: "Mit dem Channel Manager synchronisiert",
    removeSyncedTooltip: "Entfernen (Achtung: Channel Manager)",
    removeRoomTooltip: "Aus diesem Zimmer entfernen",
    add: "Hinzufügen",
    selectRoom: "Zimmer auswählen",
    derivedBadge: "Abgeleitet",
    derivedFrom: "von {name}",
    sameNameHint: "Es gibt eine weitere Rate „{name}“ mit anderem Preis oder anderen Bedingungen. Jede Karte wird einzeln bearbeitet.",
    editDerived: "Abgeleitete bearbeiten",
    deleteDerived: "Abgeleitete löschen",
  },
  derived: {
    toggle: "Abgeleitete Raten",
    empty:
      "Noch keine abgeleiteten Raten. Legen Sie eine für Booking.com, Airbnb oder bestimmte OTAs an.",
    newDerived: "Neue abgeleitete Rate",
  },
  common: {
    allRooms: "alle Zimmer",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    creating: "Wird erstellt…",
    saveChanges: "Änderungen speichern",
    removeAll: "Auswahl aufheben",
  },
  mainModal: {
    editTitle: "Hauptrate bearbeiten",
    newTitle: "Neue Hauptrate",
    nameLabel: "Name",
    namePlaceholder: "Z. B. Standardrate, Wochenende…",
    priceLabel: "Preis pro Nacht",
    occupancyLabel: "Belegung",
    minStayLabel: "Mindestaufenthalt (Nächte)",
    maxStayLabel: "Höchstaufenthalt (Nächte)",
    validityLabel: "Gültigkeit",
    permanent: "Dauerhaft",
    dateRange: "Zeitraum",
    from: "Von",
    to: "Bis",
    descriptionLabel: "Beschreibung (optional)",
    descriptionPlaceholder: "Interne Notizen zu dieser Rate…",
    searchPlaceholder: "Zimmer suchen…",
    selectAllShort: "Alle",
    noResults: 'Keine Ergebnisse für „{query}“',
    noRoomsAvailable: "Keine Zimmer verfügbar",
    editInfo: "Die Änderungen gelten für {rooms} in dieser Karte.",
    createRate: "Rate anlegen",
  },
  derivedModal: {
    editTitle: "Abgeleitete Rate bearbeiten",
    newTitle: "Neue abgeleitete Rate",
    subtitle: "Abgeleitet von {name} · {price}",
    nameLabel: "Name der abgeleiteten Rate",
    namePlaceholder: "Z. B. Booking.com, Airbnb, ohne Frühstück…",
    nameHint: "Dieser Name kennzeichnet die Rate im Channel Manager.",
    adjustTypeLabel: "Art der Anpassung",
    percentage: "Prozentsatz",
    fixedAmount: "Fester Betrag",
    adjustValueLabel: "Wert der Anpassung",
    adjustValueHint: "(negativ = Rabatt)",
    resultPriceLabel: "Resultierender Preis",
    baseLabel: "Basis",
    applyToRooms: "Auf Zimmer anwenden",
    onlyMainRooms: "Es werden nur Zimmer angezeigt, die die Hauptrate haben.",
    noRoomsWithMain: "Die Hauptrate ist noch keinem Zimmer zugewiesen.",
    selectAll: "Alle auswählen",
    editInfo:
      "Beim Bearbeiten wird die Anpassung für {rooms} mit dieser abgeleiteten Rate aktualisiert.",
    createDerived: "Abgeleitete anlegen",
  },
  removeModal: {
    title: "Aus Zimmer entfernen",
    syncWarnTitle: "Diese Rate ist mit dem Channel Manager synchronisiert",
    syncWarnBody:
      "Das Entfernen kann in Channex für dieses Zimmer {break}. Prüfen Sie vorher den Channel Manager.",
    syncWarnBreak: "die Ratensynchronisierung unterbrechen",
    confirmText: "Mit dieser Aktion wird die Rate {rate} aus Zimmer {room} entfernt.",
    roomLabel: "Zimmer",
    rateLabel: "Rate",
    statusLabel: "Status",
    syncedWithChannex: "Mit Channex synchronisiert",
    removing: "Wird entfernt…",
    removeAnyway: "Verstanden, trotzdem entfernen",
    confirm: "Aus Zimmer entfernen",
  },
  deleteModal: {
    title: "Rate löschen",
    warnTitle: "Diese Aktion kann nicht rückgängig gemacht werden",
    warnBody: "Die Rate {rate} wird aus {rooms} entfernt.",
    roomsCount: "{count} Zimmer | {count} Zimmern",
    syncedWarn:
      "Einige Zimmer sind mit Channex synchronisiert. Das kann die Ratensynchronisierung beeinflussen.",
    confirmLabel: "Geben Sie zur Bestätigung {name} ein",
    deleting: "Wird gelöscht…",
    confirm: "Endgültig löschen",
  },
  toasts: {
    loadError: "Fehler beim Laden der Hotelraten",
    mainCreated: "Rate in {count} Zimmer angelegt | Rate in {count} Zimmern angelegt",
    createdPartial: "{ok} angelegt, {fail} fehlgeschlagen",
    mainCreateFailAll: "Die Rate konnte in keinem Zimmer angelegt werden",
    mainUpdated: "Rate aktualisiert",
    updatedPartial: "{ok} aktualisiert, {fail} fehlgeschlagen",
    mainUpdateFail: "Die Rate konnte nicht aktualisiert werden",
    derivedCreated:
      "Abgeleitete Rate in {count} Zimmer angelegt | Abgeleitete Rate in {count} Zimmern angelegt",
    derivedCreateFail: "Die abgeleitete Rate konnte nicht angelegt werden",
    derivedUpdated: "Abgeleitete Rate aktualisiert",
    derivedUpdateFail: "Die abgeleitete Rate konnte nicht aktualisiert werden",
    roomAddedMain: "Rate zu {room} hinzugefügt",
    addRateError: "Fehler beim Hinzufügen der Rate",
    noMainRate: "Dieses Zimmer hat die Hauptrate nicht. Fügen Sie sie zuerst hinzu.",
    roomAddedDerived: "Abgeleitete Rate zu {room} hinzugefügt",
    addDerivedError: "Fehler beim Hinzufügen der abgeleiteten Rate",
    rateRemoved: "Rate aus {room} entfernt",
    removeError: "Fehler beim Entfernen der Rate",
    rateDeleted: "Rate gelöscht",
    deletedPartial: "{ok} gelöscht, {fail} fehlgeschlagen",
    deleteError: "Fehler beim Löschen",
  },
  errors: {
    invalidRange: "Wählen Sie einen gültigen Zeitraum",
    startAfterEnd: "Das Startdatum darf nicht nach dem Enddatum liegen",
    minStayRange: "Mindestaufenthalt: {minStay} Nächte, der Zeitraum hat aber {nights}",
  },
};
